import { Dispatch } from '@src/store'
import { useDispatch } from 'react-redux'

export function useAppDispatch(): Dispatch {
  return useDispatch<Dispatch>()
}
